@for (node of nodes(); track $index) {
  <div [class]="andClass() ? andClass() : 'ms-4'" [attr.aria-label]="'Treeview node: ' + node.title">
    @if (node.children.length) {
      <nk-caret-expander
        class="me-2"
        (click)="toggleExpand(node, !node.expanded)"
        [isExpanded]="node.expanded"
        [attr.aria-label]="'Toggle expand/collapse for ' + node.title"></nk-caret-expander>
    }

    <nk-checkbox
      class="d-inline-block"
      [style]="node.children.length ? {} : { 'margin-left': '30px' }"
      [indeterminate]="node.indeterminate"
      [ngModel]="node.checked"
      (ngModelChange)="updateChecked(node, !node.checked)"
      [attr.aria-label]="'Checkbox for ' + node.title">
      {{ node.title }}
    </nk-checkbox>

    @if (node.children.length && node.expanded) {
      <nk-treeview-node [nodes]="node.children" [attr.aria-label]="'Child nodes of ' + node.title"> </nk-treeview-node>
    }
  </div>
}
